import { render, staticRenderFns } from "./SubmitMissionProposal.vue?vue&type=template&id=0c9c3190&"
import script from "./SubmitMissionProposal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./SubmitMissionProposal.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports